<template>
  <div class="gathering">
    <h3 class="gathering__title">
      Var befinner vi oss idag
    </h3>

    <p class="gathering__text">
      Det kan tyvärr ta lite tid att samla in all information och få svar från alla institut, därav kan du se vart vi är i processen nedan.
    </p>

    <GatheringStepCounter :step="step"/>

    <h3 class="gathering__title">
      Insamlingsguiden
    </h3>

    <p class="gathering__text">
      Hoppa gärna vidare till insamlingsdelen nedan. All information du anger här är konfidentiell och vi delar den inte med någon. Har du några frågor kan du alltid kontakt vår support.
    </p>

    <div class="gathering__container">
      <h6 v-if="step < 3">
        INSAMLING steg {{ step }} av 2
      </h6>

      <GatheringStep1 v-if="step === 1" @clicked="shiftStep($event)" />

      <GatheringStep2 v-if="step === 2" @clicked="shiftStep($event)" />

      <span class="gathering__last-step" v-if="step >= 3">
        <img class="gathering__last-step__img" src="../../../assets/svg/checkmark.svg">
        <p>Tack för hjälpen! Vi har nu samlat in din data och ska analysera den.</p>
      </span>
    </div>
  </div>
</template>

<script>
import GatheringStepCounter from './GatheringStepCounter.vue';
import GatheringStep1 from './Steps/GatheringStep1.vue';
import GatheringStep2 from './Steps/GatheringStep2.vue';
import GatheringStep3 from './Steps/GatheringStep3.vue';
import LoadingSpinner from '../LoadingSpinner.vue';
import { mapGetters } from 'vuex';

export default {
  components: { GatheringStepCounter, GatheringStep1, GatheringStep2, GatheringStep3, LoadingSpinner },
  name: 'Gathering',
  data () {
    return {
      picked: '0',
      step: 1,
    }
  },
  mounted () {
    this.checkStep()
  },
  methods: {
    checkStep () {
      let access = this.user.access

      // If salary is set, next step
      if(access.income.monthlySalary != '') {
        this.step = 2
      }

      // If any field (on step) is filled, go to next step
      if (access.realEstate.value != '' && access.vehicle.value != '' && access.boat.value != '' && access.other.value != '' && access.loan.value != '') {
        this.step = 3
      }
    },
    shiftStep (e = false) {
      e.preventDefault();

      this.step++;

      if(this.step === 3) {
        let button = document.getElementById('submit');

        button.value = 'Lämna in';
      }
    },
  },
  computed: {
    ...mapGetters([ 'user' ]),
  }
}
</script>


<style lang="scss" scoped>
.gathering {
  width: 80%;
  margin: 0 auto;
  max-width: $maxWidth;

  &__title {
    text-align: center;
    margin-bottom: 1rem;
    margin-top: 5rem;
  }

  &__text {
    width: 90%;
    margin: 0 auto;
    font-size: 15px;
    text-align: center;

    @include breakpoints(medium) {
      width: 50%;
    }
  }

  &__container {
    background-color: $light;
    padding: 2rem;
    border-radius: $borderRadius;
    margin: 2rem 0;
  }

  &__last-step {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    &__img {
      height: 100px;
      margin-bottom: 2rem;
    }
  }
}
</style>